<template>
  <v-dialog
    v-model="value"
    max-width="500px"
    @click:outside="() => {}"
    @keydown.esc="close"
    persistent
  >
    <v-card style="border-radius: 8px">
      <v-card-text style="padding: 0; margin: 0">
        <div class="confirm-title">활성 정보 수정</div>
        <div class="content-paragraph">
          <div>
            <div class="content-user-info">
              <div class="name">
                {{ confirmInfos.item.admin_name }}
              </div>
              <div class="id">
                {{ confirmInfos.item.admin_id }}
              </div>
            </div>
            <div class="content-change-info">
              <div
                :class="{
                  active: confirmInfos.value,
                  active: !confirmInfos.value,
                }"
              >
                {{ confirmInfos.value ? `비활성` : `활성` }}
              </div>
              <img
                style="width: 20px; margin: 0px 4px"
                src="@/assets/arrow-right.svg"
              />
              <div
                :class="{
                  active: confirmInfos.value,
                  active: !confirmInfos.value,
                }"
                style="color: var(--primary-100)"
              >
                {{ confirmInfos.value ? `활성` : `비활성` }}
              </div>
            </div>
          </div>

          <div
            style="
              width: 336px;
              margin: 16px 0px;
              border-bottom: 1px solid var(--gray-300);
            "
          ></div>
          <div class="content-paragraph-text">
            해당 계정의 활성 상태를 변경하시겠습니까?
          </div>
          <div class="content-paragraph-text">
            활성 여부를 전환할 경우 서비스에 바로 반영됩니다.
          </div>
        </div>
        <div class="button-container">
          <div v-ripple @click="close" class="button cancel">취소</div>
          <div
            v-ripple
            @click="confirm(confirmInfos.value, confirmInfos.item.id)"
            class="button ok"
          >
            확인
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    confirmInfos: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm(value, identification) {
      this.$log.debug('this.confirmDialogInfo, event');
      this.$emit('confirmation', {
        value: value,
        identification: identification,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-title {
  text-align: center;
  padding: 40px 0px 32px 0px;

  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: var(--surface-high);
}
.content-paragraph {
  width: 336px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  .name {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: black;
  }
  .id {
    margin-left: 4px;
    color: var(--surface-medium);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
  }
}
.content-paragraph > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 24px;
}

.content-paragraph-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.5px;
  color: var(--surface-high);
}
.content-user-info {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}
.content-change-info {
  display: flex;
  flex-direction: row;
  margin-left: 20px;
}
.content-change-info > div {
  color: var(--surface-high);

  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  .active {
    width: 30px;
  }
  .inactive {
    width: 45px;
  }
}
.button-container {
  display: flex;
  width: 100%;
  padding: 40px 40px;
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-weight: 500;
    font-size: 20px;
    height: 60px;
    cursor: pointer;

    &.cancel {
      width: 162px;
      color: var(--surface-medium);
      margin-right: 10px;
      background: var(--gray-100);
    }

    &.ok {
      width: 248px;
      color: var(--surface-100);
      background: var(--primary-100);
    }
  }
}
</style>
